export function getStudentTaskResults(state, groupId) {
  return state.getIn(['rootReducer', 'studentTasks', 'taskResults', groupId]);
}

export function getStudentTaskList(state, sessionId) {
  return state.getIn(['rootReducer', 'studentTasks', 'taskList', sessionId]);
}



// WEBPACK FOOTER //
// ./data/StudentTasks/accessors.js